import {getLanguagePath} from './language';

export function getFinalizeOrderRedirectPath(search: string, pathname: string) {
  const searchParams = new URLSearchParams(search);
  if (!searchParams.has('finalizeOrder')) {
    return null;
  }

  searchParams.delete('finalizeOrder');
  return `${getLanguagePath(pathname)}/secure-checkout?${searchParams.toString()}`;
}
